import React from "react";

const TimesheetFilterButtons = ({ buttons, selected, onSelect }) => {
  return (
    <div className="flex gap-3">
      {buttons.map((btn) => (
        <button
          key={btn.label}
          onClick={() => onSelect(btn.label)}
          className={`px-4 py-2 rounded-full shadow-[0_4px_5px_0_rgba(16,16,16,0.10)] transition-all duration-200 ${
            selected === btn.label
              ? "bg-[#E17954] text-white"
              : "bg-white text-[#1D2951]"
          }`}
        >
          {btn.label}
        </button>
      ))}
    </div>
  );
};

export default TimesheetFilterButtons;
